<template>
    <div class="chart-div">
        <div id="orderEchart" ref="orderEchart" style="width: 100%; height: 100%;"></div>
    </div>
</template>

<script>

export default {
    // 折线图
    name: 'line-chart',
    props: {
        // 图表标题
        chartName: {
            type: String,
            default: '折线图'
        },
        // 图表数据
        chartData: {
            type: Array,
        },
    },
    data() {
        return {
            echart: null,

            // 图表具体数据
            seriesData: [],
            // x坐标数组
            xAxisData: [],

            
            // 图表参数
            echartOptions: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'cross',
                        label: {
                            show: false
                        }
                    },
                    formatter: '{b} <br/>订单数： {c}'
                },
                grid: {
                    left: '1.6%',
                    right: '3%',
                    top: '11%',
                    bottom: '4%',
                    borderWidth: 0,
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        axisLine: { // 坐标轴文字颜色
                            lineStyle: {
                                color: '#B7B2AF'
                            },
                            show: false
                        },
                        axisTick: { // 是否显示坐标轴刻度
                            show: false,
                        },
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        nameLocation: 'end',
                        namaTextStyle: {
                            color: '#333333',
                            fontSize: 11
                        },
                        splitLine: { // 网格线
                            show: true,
                            lineStyle: {
                                color: '#EEEEEE' // Y轴网格线颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#B7B2AF' // Y轴文字颜色
                            },
                            show: false // 隐藏Y轴线
                        },
                        axisTick: { // 隐藏小刻标
                            show: false
                        },
                    }
                ],
                series: [
                    {
                        name: this.chartName,
                        type: 'line',
                        smooth: false, //是否平滑曲线显示
                        showAllSymbol: true,
                        // symbol: 'emptyCircle',
                        symbol: 'none',
                        sampling: 'average',
                        lineStyle: { // 折线样式
                            color: '#76C819',
                            width: 1,
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: 'rgba(118,200,25, .15)' // 0% 处的颜色(靠近折线)
                                }, {
                                    offset: 1, color: 'rgba(118,200,25, .0)' // 100% 处的颜色(靠近x轴)
                                }],
                                global: false // 缺省为 false
                            }
                        },
                        data: []
                    }
                ]
            }
        }
    },
    mounted() {
        this.initChart();

        this.$root.Bus.$on('$reviewSize', () => {
            if(this.echart) {
                setTimeout(() => {
                    this.echart.resize()
                }, 400)
            }
        })
    },
    beforeDestroy() {
        this.$root.Bus.$off('$reviewSize');
    },
    methods: {
        // 初始化图表
        initChart() {
            if (!this.echart) {
                this.echart = this.$echarts.init(document.getElementById('orderEchart'))
                // this.echart = this.$echarts.init(this.$refs.orderEchart)
            }
            this.echart.setOption(this.echartOptions)
            window.onresize = this.echart.resize // 随屏幕的改变自适应大小

            this.renderingChart()
        },

        // 获取表数据，重新渲染图表
        renderingChart() {
            // console.log('this.chartData', this.chartData)

            // 如果传入的表数组为空
            if (this.chartData.length == 0) {
                // 定义一个唯一的图表id
                // this.echart = this.$echarts.init(document.getElementById('orderEchart'))
                // this.echart = this.$echarts.init(this.$refs.orderEchart)
                // this.echart.setOption(this.echartOptions)
                return;
            }

            // 如果传入的表数组不为空
            let arr1 = this.chartData;
            this.xAxisData = []; //x轴数据（字符串）
            this.seriesData = []; //y轴数据（数字）
            arr1.forEach(value =>{
                this.xAxisData.push(value.name);
                this.seriesData.push(parseInt(value.quantity));
            })
            this.echart.setOption({
                xAxis: {
                    data: this.xAxisData
                },
                series: [{
                    data: this.seriesData,
                }]
            })
        },
    }
    
}
</script>

<style scoped>
    .chart-div{
        width: 100%;
        /* width: 1292px; */
        /* height: calc( 303px - 16px - 10px - 16px ); */
    }
</style>
